import cn from "classnames"
import React from "react"

import styles from "./index.module.css"

type Props = {
  classNamePicture?: string
  logo?: string
  previewPicture?: string
}

export const Picture: React.FC<Props> = ({ logo, previewPicture, classNamePicture }) => {
  if (logo) {
    return (
      <div className={styles.Logo}>
        <img src={logo} />
      </div>
    )
  }

  if (previewPicture) {
    return (
      <div className={cn(styles.Image, classNamePicture)}>
        <img src={previewPicture} />
      </div>
    )
  }

  return null
}
